/* eslint-disable*/

import PropTypes from 'prop-types';
import {
  localSupplyScoreConvert,
  publicTransportScoreConvert,
  cultureScoreConvert,
  wohnlageScoreConvert,
} from '../../../../utils/helpers/lagescoresValuesConvert';
import Bars from '../bars';

// TODO: remove viva & style for wohnpreis production
const Mobile = ({ type, height, width, viva, item, selectedLayer }) => (
  <div className="rating__mobile">
    <div className="cards__rating">
      <div
        className="label-image__container"
        style={viva === 2 ? { marginRight: '10px' } : {}}
      >
        <img
          src={`/assets/img/cardIcons/${type}.svg`}
          height={height}
          width={width}
          alt=""
        />
      </div>
      <div
        className="rating__icon-container-label"
        style={{
          textTransform: 'capitalize',
          marginRight: '7%',
          minWidth: '10px',
          fontSize: '11px',
        }}
      >
        {type === 'opnv' ? 'ÖPNV' : type}
      </div>
      {type === 'wohnlage' && (
        <Bars
          viva={2}
          newScore={wohnlageScoreConvert(item.wohnlage)}
          layerName="Wohnlage"
          fadeColor={selectedLayer === 'Wohnlage' ? false : true}
        />
      )}
      {type === ('opnv' || 'ÖPNV') && (
        <Bars
          viva={2}
          newScore={publicTransportScoreConvert(item.publicTransport)}
          layerName="ÖPNV"
          fadeColor={selectedLayer === 'ÖPNV' ? false : true}
        />
      )}
      {type === ('kultur' || 'Kultur') && (
        <Bars
          viva={2}
          newScore={cultureScoreConvert(item.culture)}
          layerName="Kultur"
          fadeColor={selectedLayer === 'Kultur' ? false : true}
        />
      )}
      {type === ('Nahversorgung' || 'Nahversorgung') && (
        <Bars
          viva={2}
          newScore={localSupplyScoreConvert(item.localSupply)}
          layerName="Nahversorgung"
          fadeColor={selectedLayer === 'Nahversorgung' ? false : true}
        />
      )}
    </div>
  </div>
);

Mobile.propTypes = {
  type: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  viva: PropTypes.number,
};

Mobile.defaultProps = {
  viva: 0,
};

export default Mobile;
